App.DeliveryZonesController = Em.Controller.extend
  needs: ['delivery']
  session: Em.inject.service()

  zonesBinding:         'model'

  resraurantsSortOrder: [ 'name' ]
  restaurants: Em.computed.sort('controllers.delivery.restaurants', 'resraurantsSortOrder')

  # restaurantsBinding:   'controllers.delivery.restaurants'
  notifier: Em.inject.service()

  selectedRestaurant:   null
  selectedZone:         null
  organization:         Em.computed.alias('session.currentOrganization')
  isEditing:            false


  actions:
    ###
    # Геометрия зоны была изменена через редактор
    ###
    zoneAreaChanged: (zone) ->
      zone.save()
        .catch (e) =>
          messages = zone.get('errors.messages').join(', ')
          @get('notifier').pushNotification
            type: 'error'
            # todo i18n
            title: 'Ошибка создания зоны доставки'
            message: messages
        .then (zone) =>
          @transitionToRoute('delivery.zones.restaurant.zone',
            zone.get('restaurant'), zone)

      false

    ###
    # Зона была выбрана с карты
    ###
    zoneSelected: (zone) ->
      restaurant = zone?.get('restaurant') or @get('selectedRestaurant')

      if zone
        @transitionToRoute 'delivery.zones.restaurant.zone', restaurant, zone
        return false

      if restaurant
        @transitionToRoute 'delivery.zones.restaurant', restaurant
        return false

      @transitionToRoute 'delivery.zones'
      false

    ###
    # Отмена создания новой зоны
    ###
    zoneCreateCancelled: ->
      @set('selectedZone', null)

      @get('zones').forEach (zone) =>
        @get('zones').removeObject(zone) if not zone or zone.get('isNew')

      @send 'zoneSelected', null
      false

    ###
    # Нажали на "добавить зону"
    ###
    enterZoneCreation: (restaurant) ->
      @transitionToRoute('delivery.zones.restaurant.create-zone', restaurant)
      false

    ###
    # Нажали на ресторан
    ###
    changeSelectedRestaurant: (restaurant) ->
      if restaurant.get('id') is @get('selectedRestaurant.id')
        @transitionToRoute('delivery.zones')
      else
        @transitionToRoute('delivery.zones.restaurant', restaurant)
      false
